import React, { useRef } from 'react';

import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialFullWidthTextAndImageBlock, {
  FullWidthTextAndImageProps,
} from '../editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';
import { gql } from '@apollo/client';

export interface FullWidthCarouselProps {
  carouselItemsCollection: { items: FullWidthTextAndImageProps[] };
  topBlock?: boolean;
  textItem?: TextArrayProps[];
}
const EditorialFullWidthCarouselBlock = ({
  topBlock,
  carouselItemsCollection,
  textItem,
}: FullWidthCarouselProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className={
        'flex w-full snap-x snap-mandatory scroll-p-5 items-start gap-4 overflow-scroll scroll-smooth px-5 no-scrollbar sm:px-0 ' +
        (topBlock ? 'pt-5 lg:pt-0' : ' ')
      }
    >
      {carouselItemsCollection?.items?.filter(Boolean)?.map((card, index) => {
        const { body, portraitImageWrapper, landscapeImageWrapper, cardType } =
          card;
        return (
          <div
            key={index}
            className="flex w-full min-w-[300px] flex-1 select-none snap-start flex-col-reverse items-center justify-end bg-transparent md:w-0 md:justify-center md:py-0 lg:flex-row "
          >
            <EditorialFullWidthTextAndImageBlock
              cardLink={card?.cardLink ? card.cardLink : undefined}
              externalLink={card?.externalLink ? card.externalLink : undefined}
              cardType={cardType}
              textItem={textItem ? textItem[index] : undefined}
              body={body ? body : undefined}
              portraitImageWrapper={
                portraitImageWrapper ? portraitImageWrapper : undefined
              }
              landscapeImageWrapper={
                landscapeImageWrapper ? landscapeImageWrapper : undefined
              }
              topBlock={topBlock}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EditorialFullWidthCarouselBlock;
